import { useRef } from 'react';
import { observer } from 'mobx-react';

import { MoveIcon } from '@genially/icons';

import { GameControlButton } from '../../../../../../../../../../shared/application/components/GameControlButton/GameControlButton';
import { useHostGameContext } from '../../../../HostGame.context';
import {
  AnimatedWrapper,
  CountBadge,
  Wrapper,
} from './HandQueueGameControlButton.styled';

export const HandQueueGameControlButton = observer(() => {
  const { handQueueSidebar, handQueue } = useHostGameContext();

  const count = handQueue.queue.length;

  const prevCountRef = useRef(count);
  const animationKeyRef = useRef(0);

  if (count > prevCountRef.current) {
    animationKeyRef.current += 1;
  }
  prevCountRef.current = count;

  const handleClick = () => {
    handQueueSidebar.toggle();
  };

  return (
    <Wrapper $isVisible={count > 0}>
      <AnimatedWrapper key={animationKeyRef.current}>
        <GameControlButton Icon={MoveIcon} onClick={handleClick} expandRight>
          {count > 0 && <CountBadge>{count}</CountBadge>}
        </GameControlButton>
      </AnimatedWrapper>
    </Wrapper>
  );
});
